"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var MenuItem = function MenuItem(_ref) {
  var value = _ref.value,
      onChangeValue = _ref.onChangeValue,
      optionValue = _ref.optionValue,
      label = _ref.label;
  return /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("input", {
    style: {
      margin: "0px"
    },
    type: "radio",
    name: "menu-item-".concat(optionValue),
    value: optionValue,
    checked: optionValue === value,
    id: "menu-item-".concat(optionValue),
    onChange: optionValue === value ? function () {} : function () {
      onChangeValue(optionValue);
    }
  }), /*#__PURE__*/_react["default"].createElement("label", {
    htmlFor: "menu-item-".concat(optionValue)
  }, label));
};

MenuItem.propTypes = {
  value: _propTypes["default"].any.isRequired,
  onChangeValue: _propTypes["default"].func.isRequired,
  optionValue: _propTypes["default"].any.isRequired,
  label: _propTypes["default"].string.isRequired
};

var Fieldset = function Fieldset(props) {
  return /*#__PURE__*/_react["default"].createElement("fieldset", {
    className: "fieldset",
    style: {
      padding: "0.25rem"
    }
  }, props.options.map(function (option) {
    return /*#__PURE__*/_react["default"].createElement(MenuItem, _extends({
      key: option[1],
      optionValue: option[0],
      label: option[1]
    }, props));
  }));
};

Fieldset.propTypes = {
  value: _propTypes["default"].any.isRequired,
  onChangeValue: _propTypes["default"].func.isRequired,
  options: _propTypes["default"].arrayOf(_propTypes["default"].arrayOf(_propTypes["default"].any.isRequired).isRequired).isRequired //[[name,value]]

};
var _default = Fieldset;
exports["default"] = _default;